import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLog } from "../../../Hooks/useLog";

import Button from "../Atoms/Button";
import TextInfo from "../Atoms/TextInfo";
import LogPrompt from "../Molecules/LogPrompt";

import Lottie from "react-lottie";
import styles from "../../Styles/LogCard.module.css";
import loadingSpinner from "../../../Assets/90464-loading.json";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: loadingSpinner,
};

const SignInForm = () => {
  const [inputs, setInputs] = useState({
    email: "",
    password: "",
    userName: "",
    passwordCheck: "",
  });
  const [isRegister, setIsRegister] = useState(true);
  const [signUp, signIn, isLoading, error] = useLog();
  const navigate = useNavigate();

  const inputsHandler = (value) => {
    setInputs({
      email: value.email,
      password: value.password,
      userName: value.userName,
      passwordCheck: value.passwordCheck,
    });
  };

  const changeLogStatus = () => {
    setIsRegister(!isRegister);
  };

  const formHandler = async (e) => {
    e.preventDefault();
    let userParam;
    if (!isRegister) {
      userParam = await signUp(
        inputs.email,
        inputs.password,
        inputs.userName,
        inputs.passwordCheck
      );
      error === "" && navigate(`/${userParam}`, { replace: true });
      return;
    }
    if (isRegister) {
      userParam = await signIn(inputs.email, inputs.password);
      error === "" && navigate(`/${userParam}`, { replace: true });
      return;
    }
  };

  return (
    <>
      {error !== "" && <h3>{error}</h3>}
      {!isLoading && error === "" ? (
        <form className={styles.log_form} onSubmit={formHandler}>
          <div className={styles.log_form__header}>
            <h2>{isRegister ? "Welcome Back 👋" : "Join 🚀"}</h2>
          </div>
          <div className={styles.log_form__inputs}>
            <LogPrompt inputs={inputsHandler} isRegister={!isRegister} />
          </div>
          <div className={styles.log_form__actions}>
            <TextInfo onClick={changeLogStatus}>
              {!isRegister ? "Login Instead" : "Sign Up"}
            </TextInfo>
            <Button log={true}>{!isRegister ? "Register" : "Log In"}</Button>
          </div>
        </form>
      ) : (
        <Lottie options={defaultOptions} height={300} width={300} />
      )}
    </>
  );
};

export default SignInForm;
